import { Root, Trigger, List, Content } from '@radix-ui/react-tabs';
import { IStorageProps } from '../Storage';
import FolderCard from './FolderCard/FolderCard';

import styles from './StorageFolderList.module.scss';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StorageFolderFiles from '../StorageFolderFiles/StorageFolderFiles';
import { t } from 'i18next';
import PhotoStorageIcon from '~/assets/svg/newSvg/picture.svg?react';

const StorageFolderList = ({ assets, refetchAssets }: IStorageProps) => {
  const [activeTab, setActiveTab] = useState('');
  const navigate = useNavigate();

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    navigate(`/documents/${value}`);
  };

  useEffect(() => {
    const currentPath = location.pathname
      .split('/')
      .filter(item => item !== '');

    if (currentPath.length < 2) {
      setActiveTab('');
    } else {
      setActiveTab(currentPath[currentPath.length - 1]);
    }
  }, []);

  return (
    <div className={styles.listWrapper}>
      <Root
        value={activeTab}
        onValueChange={handleTabChange}
        className={styles.root}
      >
        <div className={styles.foldersWrapper}>
          <p className={styles.foldersTitle}>{t('assets')}</p>
          <List className={styles.list}>
            <button
              type="button"
              className={styles.photoStorageCard}
              onClick={() => navigate('/documents/photo-storage')}
            >
              <PhotoStorageIcon className={styles.photoStorageIcon} />
              <p className={styles.photoStorageName}>{t('photo_storage')}</p>
            </button>
            {assets?.map(item => (
              <Trigger
                value={String(item.id)}
                key={item.id}
                className={styles.item}
              >
                {<FolderCard asset={item} />}
              </Trigger>
            ))}
          </List>
        </div>

        {activeTab ? (
          <Content value={activeTab}>
            <div className={styles.filesWrapper}>
              <p className={styles.filesTitle}>{t('files')}</p>
              <StorageFolderFiles
                id={activeTab}
                refetchAssets={refetchAssets}
              />
            </div>
          </Content>
        ) : null}
      </Root>
    </div>
  );
};

export default StorageFolderList;
